import { Setting } from '../types/constant/PagesPropsType';
import { BillingAttemptApiType, SubscriptionApiType } from '../types/api/SubscriptionApiType';
import axios from 'axios';
import { CUSTOMER_API_URL } from '../constants';

export const useNewOrder = () => {
  /**
   * 定期購買の商品を注文する
   *
   * @param setting
   * @param subscription
   * @param success
   * @param failed
   * @param completion
   */
  const newOrder = (
    setting: Setting,
    subscription: SubscriptionApiType,
    success: (billingAttempt: BillingAttemptApiType) => void,
    failed: (responseStatus: number) => void,
    completion: () => void
  ) => {
    axios
      .post(
        `${CUSTOMER_API_URL}?action=newOrder`,
        {
          subscriptionId: subscription.subscriptionContractId,
        },
        { headers: { Authorization: setting.token } }
      )
      .then((response) => {
        success(response.data as BillingAttemptApiType);
      })
      .catch((e) => {
        console.log(e);
        failed(e.response.status);
      })
      .finally(() => completion());
  };

  return {
    newOrder,
  };
};
